export const getMargaretRiverData = () => ({
  name: "Margaret River",
  country: "Australie",
  description: "Margaret River est une région viticole prestigieuse de l'Australie-Occidentale, réputée pour ses vins blancs élégants et ses rouges structurés. Son climat méditerranéen et ses influences océaniques créent des conditions idéales pour des vins de grande finesse.",
  type: "region",
  mapAreas: [
    { region: "Margaret River", x: 25, y: 85, color: "#8a4a8a", size: 4 }
  ],
  statistics: {
    totalArea: "6,000 ha",
    production: "0.4 million hectolitres",
    appellations: "Margaret River GI",
    subregions: "4 sous-régions principales",
    exportPercentage: "40%"
  },
  characteristics: {
    climate: "Climat méditerranéen avec influence océanique, étés chauds et secs, hivers doux",
    soil: "Sols granitiques, argileux, sableux, excellente diversité géologique",
    viticulture: "Viticulture moderne, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Cabernet Sauvignon structurés et élégants, Shiraz puissants, assemblages complexes",
    white: "Chardonnay élégants et complexes, Sauvignon Blanc frais, Sémillon aromatiques",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Margaret River a débuté dans les années 1960, inspirée par les vins de Bordeaux. La région s'est rapidement imposée comme l'une des plus prestigieuses d'Australie, reconnue pour ses vins de qualité exceptionnelle.",
  foodPairing: "Cuisine australienne : fruits de mer, poissons, viandes rouges, fromages affinés, cuisine fusion.",
  subregions: {
    "wilyabrup": {
      name: "Wilyabrup",
      description: "Cœur historique de la région, réputé pour ses Cabernet Sauvignon et Chardonnay de qualité exceptionnelle.",
      characteristics: {
        climate: "Méditerranéen, influence océanique",
        soil: "Sols granitiques et argileux",
        viticulture: "Vignobles historiques, rendements limités"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Sémillon"],
        red: ["Cabernet Sauvignon", "Shiraz", "Merlot"]
      },
      wineStyles: {
        "cabernet-sauvignon": "Rouges structurés et élégants",
        "chardonnay": "Blancs complexes et aromatiques"
      },
      foodPairing: "Viandes rouges, fromages affinés, cuisine gastronomique"
    },
    "yallingup": {
      name: "Yallingup",
      description: "Zone côtière, connue pour ses vins blancs frais et ses rouges fruités.",
      characteristics: {
        climate: "Méditerranéen, forte influence océanique",
        soil: "Sols sableux et argileux",
        viticulture: "Vignobles modernes, proximité de l'océan"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Sémillon"],
        red: ["Shiraz", "Cabernet Sauvignon", "Merlot"]
      },
      wineStyles: {
        "blanc": "Blancs frais et aromatiques",
        "rouge": "Rouges fruités et équilibrés"
      },
      foodPairing: "Fruits de mer, poissons, cuisine côtière"
    },
    "wallcliffe": {
      name: "Wallcliffe",
      description: "Zone méridionale, réputée pour ses vins rouges structurés et ses blancs complexes.",
      characteristics: {
        climate: "Méditerranéen, influence océanique",
        soil: "Sols argileux et calcaires",
        viticulture: "Vignobles modernes, qualité privilégiée"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc"],
        red: ["Cabernet Sauvignon", "Shiraz", "Merlot"]
      },
      wineStyles: {
        "rouge": "Rouges structurés et complexes",
        "blanc": "Blancs complexes et aromatiques"
      },
      foodPairing: "Viandes rouges, volailles, cuisine traditionnelle"
    },
    "karridale": {
      name: "Karridale",
      description: "Zone la plus méridionale, connue pour ses vins blancs frais et ses rouges élégants.",
      characteristics: {
        climate: "Plus frais, influence océanique",
        soil: "Sols granitiques et argileux",
        viticulture: "Vignobles modernes, climat plus frais"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Sémillon"],
        red: ["Shiraz", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "blanc": "Blancs frais et tendus",
        "rouge": "Rouges élégants et fruités"
      },
      foodPairing: "Poissons, volailles, cuisine légère"
    }
  }
}); 